import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-olive-deep bg-olive-deep/20" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3">
          <LogoMark size={40} />
          <span className="font-stencil text-lg text-foreground">OPERATION FIX-IT</span>
        </div>
        <p className="mt-4 text-xs text-muted-foreground leading-relaxed max-w-xs">
          Elite home maintenance and repair. Every job executed with military precision.
        </p>
        <div className="mt-8 flex items-center gap-4" data-testid="owner-portrait">
          <div className="border border-khaki/60 p-1 dogtag">
            <img
              src="/donald-army.webp"
              alt="Donald Broughton, U.S. Army veteran and owner of OPERATION FIX-IT"
              className="w-20 h-24 object-cover"
              data-testid="owner-portrait-image"
            />
          </div>
          <div className="leading-tight">
            <span className="block text-xs font-bold tracking-[0.15em] text-khaki">DONALD BROUGHTON</span>
            <span className="block text-[10px] tracking-[0.25em] text-coyote mt-1.5">OWNER-OPERATOR</span>
            <span className="block text-[10px] tracking-[0.25em] text-coyote mt-0.5">U.S. ARMY VETERAN</span>
          </div>
        </div>
      </div>
      <div>
        <p className="text-[10px] tracking-[0.3em] text-coyote mb-4">OPERATIONS</p>
        <ul className="space-y-2 text-xs text-muted-foreground">
          <li><a href="#services" className="hover:text-khaki transition-colors duration-300" data-testid="footer-services-link">Service Arsenal</a></li>
          <li><a href="#protocol" className="hover:text-khaki transition-colors duration-300" data-testid="footer-protocol-link">Field Protocol</a></li>
          <li><a href="#deploy" className="hover:text-khaki transition-colors duration-300" data-testid="footer-deploy-link">Request Service Call</a></li>
          <li><a href="/pay" className="hover:text-khaki transition-colors duration-300" data-testid="footer-pay-link">Pay an Invoice</a></li>
        </ul>
      </div>
      <div>
        <p className="text-[10px] tracking-[0.3em] text-coyote mb-4">COMMAND</p>
        <ul className="space-y-2 text-xs text-muted-foreground">
          <li><a href="tel:2832370359" className="hover:text-khaki transition-colors duration-300" data-testid="footer-phone-link">283-237-0359</a></li>
          <li><a href="mailto:at-ease@operationfixit.net" className="hover:text-khaki transition-colors duration-300 break-all" data-testid="footer-email-link">at-ease@operationfixit.net</a></li>
          <li className="text-coyote">Northern Kentucky // Cincinnati Metro</li>
          <li className="text-coyote">Mon–Fri 9AM–5PM // Emergency & Weekends Available</li>
          <li><a href="/admin/login" className="hover:text-khaki transition-colors duration-300" data-testid="footer-admin-link">Command Login</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-olive-deep">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2">
        <span className="text-[10px] tracking-[0.25em] text-coyote">© {new Date().getFullYear()} OPERATION FIX-IT // ALL RIGHTS RESERVED</span>
        <span className="text-[10px] tracking-[0.25em] text-khaki font-bold" data-testid="footer-veteran-badge">★ VETERAN OWNED &amp; OPERATED</span>
        <span className="text-[10px] tracking-[0.25em] text-coyote">MISSION: FIX IT RIGHT <span className="text-alert">_</span></span>
      </div>
    </div>
  </footer>
);
